/**
 * The admin app's entry.
 *
 * The same two stylesheets the Studio loads, in the same order — the admin wears the Studio's
 * design system rather than a look of its own (`admin/01`). There is no third sheet and no
 * theme toggle: an internal tool follows the machine's `prefers-color-scheme` and stops there.
 */

import '@atlas-nook/design-system/tokens.css';
import '@atlas-nook/design-system/studio.css';
import './admin.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';

const root = document.getElementById('root');
if (root === null) throw new Error('index.html is missing #root');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
